import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import ChannelSliderBar from "./ChannelSliderBar";
import KeywordSearch from "./dev/KeywordSearch";
import CountrySearch from "./dev/CountrySearch";
import CategorySearch from "./dev/CategorySearch";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
const styles = {
  root: {
    display: "flex",
    alignItems: "center",
    width: "80%",
    border: "1px solid #a0a0a0",
    boxShadow: "none",
  },
  input: {
    marginLeft: 8,
    flex: 1,
    color: "#787878",
    fontSize: "16px",
    padding: 5,
  },
  iconButton: {
    padding: 5,
  },
};
class ChannelSearch extends Component {
  state = {
    urlArgs: {
      keyword: "",
      country: "",
      category: "",
      subscriberCountFrom: 10000,
      subscriberCountTo: 2000000,
      recentAvgViewCountFrom: 0,
      recentAvgViewCountTo: 2000000,
      recentAvgEngageRateFrom: 0,
      recentAvgEngageRateTo: 7,
      monthSubscriberCountFrom: 0,
      monthSubscriberCountTo: 30000,
      monthSubscriberRateFrom: 0,
      monthSubscriberRateTo: 30,
      monthViewCountFrom: 0,
      monthViewCountTo: 35000000,
      monthViewRateFrom: 0,
      monthViewRateTo: 15,
    },
    keyword: "",
  };
  componentDidMount = () => this.urlEncode();
  heyPleaseUpgrade = () => {
    this.props.dispatch({
      type: "togglePaymentField",
      isPaymentGuideActive: true,
      paymentGuideMinPlan: "Brand",
    });
    return;
  };
  urlEncode = () => {
    const { urlArgs, keyword } = this.state;
    const { setCurrentPage } = this.props;
    let url = Object.entries(urlArgs)
      .map((pairs) => {
        const [key, value] = pairs.map(encodeURIComponent);
        return `${key}=${value}`;
      })
      .join("&");
    const { REACT_APP_URI = "/" } = process.env;
    url = `${REACT_APP_URI}/Info/?` + url;
    this.props.dispatch({
      type: "CHANGE_CHANNELURL",
      channelUrl: url,
    });
    this.props.dispatch({
      type: "CHANGE_CHANNELKEYWORD",
      channelKeyword: keyword,
    });
    setCurrentPage(1);
  };
  SetSliderRange = (name) => ([from, to]) => {
    const {
      user: { plan, auth },
    } = this.props;
    if (auth === "notSignIn") {
      this.props.dispatch({ type: "toggleUserField", condition: "signIn" });
      return;
    }
    if (plan !== "Brand" && plan !== "Agency") {
      this.heyPleaseUpgrade();
      return;
    }
    this.setState(
      {
        urlArgs: {
          ...this.state.urlArgs,
          [name + `From`]: from,
          [name + `To`]: to,
        },
      },
      () => {
        this.urlEncode();
      }
    );
    return [from, to];
  };
  keywordInput = (e) => this.setState({ keyword: e.target.value });
  keywordSubmit = (e) => {
    const {
      user: { plan, auth },
    } = this.props;
    if (auth === "notSignIn") {
      this.props.dispatch({ type: "toggleUserField", condition: "signIn" });
      return;
    }
    if (plan !== "Brand" && plan !== "Agency") {
      this.heyPleaseUpgrade();
      return;
    }
    const { keyword } = this.state;
    this.setState(
      {
        urlArgs: {
          ...this.state.urlArgs,
          keyword: keyword,
        },
      },
      () => {
        this.urlEncode();
      }
    );
  };
  countrySelect = (e) => {
    const {
      user: { plan, auth },
    } = this.props;
    if (auth === "notSignIn") {
      this.props.dispatch({ type: "toggleUserField", condition: "signIn" });
      return;
    }
    if (plan !== "Brand" && plan !== "Agency") {
      this.heyPleaseUpgrade();
      return;
    }
    if (e !== null)
      this.setState(
        { urlArgs: { ...this.state.urlArgs, country: e.value } },
        () => {
          this.urlEncode();
        }
      );
  };
  categorySelect = ({ value }) => {
    const {
      user: { plan, auth },
    } = this.props;
    if (auth === "notSignIn") {
      this.props.dispatch({ type: "toggleUserField", condition: "signIn" });
      return;
    }
    if (plan !== "Brand" && plan !== "Agency") {
      this.heyPleaseUpgrade();
      return;
    }
    this.setState(
      { urlArgs: { ...this.state.urlArgs, category: value } },
      () => {
        this.urlEncode();
      }
    );
  };
  renderInput = () => {
    const { classes, messages } = this.props;
    const { keyword } = this.state;
    const { keywordInput, keywordSubmit } = this;
    return (
      <Paper className={classes.root} elevation={1}>
        <InputBase
          className={classes.input}
          placeholder={messages.info_list_channel_search_tip}
          onInput={keywordInput}
          onKeyPress={(e) => e.key === "Enter" && keywordSubmit()}
          value={keyword}
          type="text"
        />
        <IconButton
          onClick={() => keywordSubmit()}
          className={classes.iconButton}
          aria-label="Search"
        >
          <SearchIcon />
        </IconButton>
      </Paper>
    );
  };
  render() {
    const {
      SetSliderRange,
      keywordInput,
      keywordSubmit,
      countrySelect,
      categorySelect,
    } = this;
    const {
      urlArgs,
      urlArgs: { country, category },
      keyword,
    } = this.state;
    const {
      messages,
      tour: { isInfoListTourActive },
    } = this.props;
    return (
      <ChannelSearchWrap>
        <TopField>
          <KeywordSearch
            tourId="user_tour_infolist_1"
            id={"ga_channel_search_input"}
            keyword={isInfoListTourActive ? "Pewdiepie" : keyword}
            keywordInput={keywordInput}
            keywordSubmit={keywordSubmit}
            keywordType={messages.info_list_channel_search_tip}
          />
          <Wrap>
            <CountrySearch country={country} countrySelect={countrySelect} />
            <CategorySearch
              category={category}
              categorySelect={categorySelect}
            />
          </Wrap>
        </TopField>
        <ChannelSliderBar SetSliderRange={SetSliderRange} urlArgs={urlArgs} />
      </ChannelSearchWrap>
    );
  }
}
ChannelSearch.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
  return {
    user: state.User,
    infoList: state.InfoList,
    messages: state.Messages,
    tour: state.Tour,
  };
};
export default withStyles(styles)(connect(mapStateToProps)(ChannelSearch));

const ChannelSearchWrap = styled.div`
  display: flex;
  flex-direction: column;
`;
const TopField = styled.div`
  grid-area: TopField;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
`;
const Wrap = styled.div`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/InfoList/Search/ChannelSearch.js